<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-manager-add-user">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 col-sm-12 p-4">
            <form v-on:submit.prevent="userManagerAddUser">
              <!-- <h4>User Manager</h4> -->
              <!-- <hr /> -->
              <h4>Add user</h4>
              <!-- Breadcrumb start -->
              <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
                <router-link
                  :to="{ name: 'Users' }"
                  class="d-inline"
                  style="font-weight: normal;"
                >
                  Users
                </router-link>
                <p class="d-inline pl-1 pr-1">/</p>
                <router-link
                  :to="{}"
                  class="d-inline"
                  style="font-weight: normal;"
                >
                  Add user
                </router-link>
              </div>
              <!-- Breadcrumb end -->
              <br />
              <strong>*These fields are required</strong>
              <div class="row my-3">
                <div class="col-sm-12 col-lg-8 col-md-8">
                  <div class="row my-2">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Username*:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        v-model="UserName"
                        name="userName"
                        type="text"
                        value=""
                        autocomplete="off"
                      ></b-form-input>
                      <small>(no spaces, must be unique for each user)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Password*:</strong>
                    </div>

                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        style="cursor: not-allowed;"
                        disabled
                        v-model="Password"
                        type="password"
                        name="password"
                        value=""
                        @focus="handleType"
                        @blur="handleType"
                        autocomplete="off"
                      ></b-form-input>
                      <small>(Password is autogenerated by system)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Points:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="StartingPoints"></b-form-input>
                    </div>
                  </div>

                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Single Item Only:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-radio-group
                        v-model="SingleItem"
                        :options="SingleItemOptions"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                      <small
                        >(Yes = starting points become max point value for this
                        item)</small
                      >
                    </div>
                  </div>
                  <!-- Show transaction Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Show transaction:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-radio-group
                        v-model="ShowTransaction"
                        :options="ShowTransactionOptions"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                      <small
                        >(Yes = Shows transcation report for normal
                        users)</small
                      >
                    </div>
                  </div>
                  <!-- Show transaction End -->
                  <!-- Super admin ace Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Super admin ace and bravo:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-radio-group
                        v-model="SuperAdminAce"
                        :options="SuperAdminAceOptions"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                      <small>(Yes = Super admin for Ace and Bravo)</small>
                    </div>
                  </div>
                  <!-- Super admin ace End -->
                  <!-- Code Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Code:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Code"></b-form-input>
                    </div>
                  </div>
                  <!-- Code End -->
                  <!-- Client List (single) Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Client:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-select
                        v-model="SelectClient"
                        :options="SelectClientOptions"
                      ></b-form-select>
                    </div>
                  </div>
                  <!-- Client List (single) End -->
                  <!-- Job Title Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Job title:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="JobTitle"></b-form-input>
                    </div>
                  </div>
                  <!-- Job Title End -->
                  <!-- First Name Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>First Name:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="FirstName"></b-form-input>
                    </div>
                  </div>
                  <!-- First Name End -->
                  <!-- Middle Name Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Middle Name:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="MiddleName"></b-form-input>
                    </div>
                  </div>
                  <!-- Middle Name End -->
                  <!-- Last Name Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Last Name:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="LastName"></b-form-input>
                    </div>
                  </div>
                  <!-- Last Name End -->
                  <!-- Address ATTN Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Address ATTN:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="AddressAtn"></b-form-input>
                    </div>
                  </div>
                  <!-- Address ATTN End -->
                  <!-- Address Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Address"></b-form-input>
                    </div>
                  </div>
                  <!-- Address End -->
                  <!-- City Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>City:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="City"></b-form-input>
                    </div>
                  </div>
                  <!-- City End -->
                  <!-- State Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>State:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="State"></b-form-input>
                    </div>
                  </div>
                  <!-- State End -->
                  <!-- Zip Code Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Zip Code:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="ZipCode"></b-form-input>
                    </div>
                  </div>
                  <!-- Zip Code End -->
                  <!-- Day Phone Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Day Phone:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="DayPhone"></b-form-input>
                    </div>
                  </div>
                  <!-- Day Phone End -->
                  <!-- Evening Phone Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Evening Phone:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="EveningPhone"></b-form-input>
                    </div>
                  </div>
                  <!-- Evening Phone End -->
                  <!-- Email Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Email:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input type="text" v-model="Email"></b-form-input>
                    </div>
                  </div>
                  <!-- Email Start -->
                  <!-- SSN Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Social Security No.:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="SocialSecurityNo"></b-form-input>
                      <small>(Optional, no dashes. Ex: 123456789)</small>
                    </div>
                  </div>
                  <!-- SSN End -->
                  <!-- Select Admin Start -->
                  <div class="row my-3 ">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Admin:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-select v-model="SelectAdmin">
                        <option :value="1">Yes</option>
                        <option :value="0" style="text-transform:capitalize"
                          >No</option
                        >
                      </b-form-select>
                    </div>
                  </div>
                  <!-- Select Admin End -->
                  <!-- Client List (multiple) Start -->
                  <div class="row my-3 form-group">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Admin:</strong>
                    </div>
                    <div class="col">
                      <select
                        size="6"
                        v-model="SelectAdminList"
                        multiple
                        class="form-control"
                        disabled
                      >
                        <option
                          v-for="client in getClientList"
                          :key="client.client_id"
                          :value="client.client_id"
                          >{{ client.client_name }}</option
                        >
                      </select>
                      <small
                        >When no clients are selected from this list, this admin
                        will only have access to the client that they are
                        assigned to above. Selecting 1 or more clients from this
                        list will give this admin access to the features of
                        these clients. If 1 or more clients are selected, then
                        that admin's own client must be selected for that admin
                        to see their own client users.</small
                      >
                    </div>
                  </div>
                  <!-- Client List (multiple) End -->
                  <!-- Joining Date Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Joining Date:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="JoiningDate"></b-form-input>
                      <small>(Month/Day/Year) eg: 12/12/2022</small>
                    </div>
                  </div>
                  <!-- Joining Date End -->
                  <!-- Birthday Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Birthday:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthDay"></b-form-input>
                      <small>(Month/Day) eg: 12/12</small>
                    </div>
                  </div>
                  <!-- Birthday End -->
                  <!-- Birthyear Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Birthyear:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthYear"></b-form-input>
                      <small>(Year) eg: 2022</small>
                    </div>
                  </div>
                  <!-- Birthyear End -->
                </div>
              </div>
              <!-- Button Area Start-->
              <div class="mt-3">
                <input
                  class="btn btn-primary btn-sm-block mr-2"
                  type="submit"
                  name="add"
                  value="Add"
                />
                <router-link
                  :to="{
                    name: 'Users',
                  }"
                  @click.native="scrollToTop"
                  class="btn btn-danger text-white btn-sm-block mr-2"
                  type="button"
                  >Cancel</router-link
                >
              </div>
              <!-- Button Area End-->
            </form>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

import {
  getCustomizedTimestamp,
  validateMonthDateYearFormat,
  validateMonthDay,
  validateYear,
} from "@/utilities/date.js";

export default {
  name: "AdminUserManagerAddUser",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: DivvyAdminSidebar,
  },

  data() {
    return {
      Email: "",
      UserName: "",
      Password: "password",
      StartingPoints: 0,
      SingleItem: false,
      SingleItemOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      ShowTransaction: false,
      ShowTransactionOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      SuperAdminAce: false,
      SuperAdminAceOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      Code: "",
      SelectClient: null,
      SelectClientOptions: [],
      JobTitle: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
      AddressAtn: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      DayPhone: "",
      EveningPhone: "",
      SocialSecurityNo: "",
      SelectAdmin: 0,
      SelectAdminList: [],
      JoiningDate: "",
      BirthDay: "",
      BirthYear: "",
      fieldTypes: {
        password: "text",
      },
    };
  },

  computed: {
    getClientList() {
      return this.$store.getters["manageUsers/getClientList"];
    },
  },

  watch: {
    getClientList(getClientList) {
      var datas = [];
      getClientList.map(function(data) {
        datas.push({
          value: data.client_id,
          text: data.client_name,
        });
      });

      this.SelectClient = datas.length > 0 ? datas[0].value : null;
      this.SelectClientOptions = datas;
    },

    SelectAdmin(newVal, oldVal) {
      if (oldVal === 1 && newVal === 0) {
        this.SelectAdminList = [];
      }
    },
  },

  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersmodule",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    userManagerAddUser: function() {
      if (!this.UserName) {
        alert("Username is required.");
      } else if (!this.Password) {
        alert("Password is required.");
      }

      if (this.UserName.indexOf(" ") >= 0) {
        console.log("Yes");
        alert("no spaces are allowed in username");
        return;
      }

      this.JoiningDate =
        this.JoiningDate && validateMonthDateYearFormat(this.JoiningDate)
          ? this.JoiningDate
          : "";
      this.BirthDay =
        this.BirthDay && validateMonthDay(this.BirthDay) ? this.BirthDay : "";
      this.BirthYear =
        this.BirthYear && validateYear(this.BirthYear) ? this.BirthYear : "";

      if (this.UserName && this.Password) {
        const params = {
          username: this.UserName,
          password: this.Password,
          code: this.Code,
          company: "",
          points: +this.StartingPoints,
          admin: +this.SelectAdmin,
          singleitem: this.SingleItem,
          firstname: this.FirstName,
          middleinitial: this.MiddleName,
          lastname: this.LastName,
          address1: this.AddressAtn,
          address2: this.Address,
          city: this.City,
          state: this.State,
          zip: this.ZipCode,
          dayphone: this.DayPhone,
          eveningphone: this.EveningPhone,
          email: this.Email,
          ssn: this.SocialSecurityNo,
          joiningdate: this.JoiningDate,
          birthday: this.BirthDay,
          birthyear: this.BirthYear,
          client_id: +this.SelectClient,
          client_ids: this.SelectAdminList,
          istranscreport: this.ShowTransaction,
          superadminacebravo: this.SuperAdminAce,
          jobTitle: this.JobTitle,
        };

        console.log(params);

        this.$store
          .dispatch("manageUsers/addUser", params)
          .then((data) => {
            if (data.message === "Username already exists") {
              alert(data.message);
            } else {
              console.log("succesfully updated the user", data);
              this.$router.push({
                name: "DivvyAdminUsersAddUpdScreen",
                params: { Name: this.UserName, action: "added" },
              });
            }
          })
          .catch(() => {
            console.log("error occured in users < UsersAddUser");
          });
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;

      if (type === "blur" && !value) {
        this.fieldTypes[name] = "text";
      } else {
        this.fieldTypes[name] = "password";
      }
    },
  },
  mounted() {
    this.$store.dispatch("manageUsers/fetchGetUserClients");
  },
};
</script>

<style lang="scss" scoped>
.admin-user-manager-add-user {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.datetime-style {
  background-color: blue;
}
</style>
